import $ from 'jquery';

let popovered = false;

function hidePopover(e) {
    // if (popovered && !$(e.target).closest(popovered.attr('href') || popovered.attr('data-target')).length) {
    if (popovered && !$(e.target).closest('.popover').length) {
        popovered.popover('hide');
        popovered = false;
    }
}

$(function () {
    $(document).on('click popovers.hideall', hidePopover);
});

export function popovers(context) {
    $('[data-toggle="popover"]:not([data-content])', context).each(function () {
        let me = $(this);
        me.data('content', $(me.attr('data-target') || me.attr('href')).clone());
        const placement = me.attr('data-placement') || 'top';
        me.popover({
            content: me.data('content'),
            html: true,
            placement: placement,
            sanitize: false,
            trigger: 'manual'
        }).on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (popovered) {
                if (me.attr('href') && popovered === me) {
                    window.location = me.attr('href');
                }
                else {
                    popovered.popover('hide');
                }
            }
            popovered = me.popover('toggle');
        });
    });
    $('[data-toggle="popover"][data-content]', context).popover();
}

export default {
    popovers
};